import { ReportViewerState, VizTypes } from '@mode/reports/sandbox/contract';
import * as $ from 'jquery';
import { createSelector } from 'reselect';
import { ROW_HEIGHT_ATTR, VIZ_SELECTORS } from '../../../../common/constants';
import {} from '../../../../common/types';

export namespace LayoutSelectors {
  export const parsedLayout = createSelector(
    (state: ReportViewerState) => state.reportFeature.serializedReport.report.layout,
    (layout) => $('<div>' + (layout || '') + '</div>') // return just <div></div> instead of <div>undefined</div> if layout is undefined
  );

  export const vizElementsInLayout = createSelector(parsedLayout, ($layout) => $layout.find(VIZ_SELECTORS));
  export const hasCustomStyle = createSelector(parsedLayout, (parsed) => parsed.find('style').length > 0);
  export const hasCustomScripts = createSelector(parsedLayout, (parsed) => parsed.find('script').length > 0);
  export const disableVirtualScroll = createSelector(
    parsedLayout,
    ($layout) =>
      $layout
        .contents()
        .filter((i, n) => n.nodeType === 8) // Looking for comment nodes
        .toArray()
        .some((n) => n.textContent.includes('no-virtual-scroll')) || // example: <!-- no-virtual-scroll -->
      $layout.find('.mode-grid.no-virtual-scroll').length > 0 // For backwards compatibility, the HTML comment is preferred
  );

  export function createTextContentSelector(token: string) {
    return createSelector(vizElementsInLayout, ($elements) => $elements.filter('#text_' + token).html());
  }

  export function createRowHeightSelector(type: VizTypes, token: string) {
    return createSelector(LayoutSelectors.parsedLayout, ($layout) => {
      const $viz = $layout.find(`#${type}_${token}`);
      const $row = $viz.parents('div.row');
      return $row.attr(ROW_HEIGHT_ATTR);
    });
  }
}
